export const positionLevelList = [
  {value: 'entry', label: 'Entry Level'},
  {value: 'mid', label: 'Mid Level'},
  {value: 'senior', label: 'Senior Level'},

]
